import { ApiUrl } from "../../../Constants/Api";
import {
  REQUEST_METHOD,
  WebService,
} from "../../WebServiceManager/RequestService";
import DashBoardRequestBody from "./DashBoardRequestBody";

export default class DashBoardService {
     request = new DashBoardRequestBody();
      static shared = new DashBoardService();

      dashBoardListRequest = (payload) => {
        return new Promise((resolve, reject) => {
          WebService.clientShared
            .callServiceApi(
              ApiUrl.getAllListCount(payload),
              this.request.dashBoardListRequest( REQUEST_METHOD.GET)
            )
            .then((response) => {
              resolve(response);
            }) 
            .catch((error) => {
              reject(error);
            });
        });
      } 

      empDashBoardListRequest = (payload) => {
        return new Promise((resolve, reject) => {
          WebService.clientShared
            .callServiceApi(
              ApiUrl.getEmpTimesheets(payload),
              this.request.empDashBoardListRequest( REQUEST_METHOD.GET)
            )
            .then((response) => {
              resolve(response);
            }) 
            .catch((error) => {
              reject(error);
            });
        });
      }

      empDashBoardMonthlyHoursListRequest = (payload) => {
        return new Promise((resolve, reject) => {
          WebService.clientShared
            .callServiceApi(
              ApiUrl.getEmpMonthlyHours(payload),
              this.request.empDashBoardMonthlyHoursListRequest(REQUEST_METHOD.GET)
            )
            .then((response) => {
              resolve(response);
            }) 
            .catch((error) => {
              reject(error);
            });
        });
      }


      timesheetCountRequest = (payload) => {
        return new Promise((resolve, reject) => {
          WebService.clientShared
            .callServiceApi(
              ApiUrl.getTimesheetCount(payload),
              this.request.timesheetCountRequest( REQUEST_METHOD.GET)
            )
            .then((response) => {
              resolve(response);
            }) 
            .catch((error) => {
              reject(error);
            });
        });
      }

      empWishesRequest = (payload) => {
        return new Promise((resolve, reject) => {
          WebService.clientShared
            .callServiceApi(
              ApiUrl.getEmpWishes(payload),
              this.request.empWishesRequest( REQUEST_METHOD.GET)
            )
            .then((response) => {
              resolve(response);
            }) 
            .catch((error) => {
              reject(error);
            });
        });
      }

      weeklyEfficiencyRequest = (payload) => {
        return new Promise((resolve, reject) => {
          WebService.clientShared
            .callServiceApi(
              ApiUrl.getWeeklyEfficiency(payload),
              this.request.weeklyEfficiencyRequest( REQUEST_METHOD.GET)
            )
            .then((response) => {
              resolve(response);
            }) 
            .catch((error) => {
              reject(error);
            });
        });
      }
}